const deepEqual = require('fast-deep-equal');
export function metricWasSentWith(mockSendMetric, metricData) {
    const calls = mockSendMetric.mock.calls;
    if (calls.length) {
        const wasSentWith = calls.some((call) => {
            return (call[0] &&
                call[0].EventData &&
                call[0].EventData.some((mockMetricData) => {
                    return callContainsData(mockMetricData, metricData);
                }));
        });
        if (!wasSentWith) {
            throw `mockSendMetric was not called with expected metric.
            \nExpected: ${JSON.stringify(metricData, null, 2)}.
            \nFirst call: ${JSON.stringify(calls[0][0].EventData[0], null, 2)}`;
        }
        return wasSentWith;
    }
    else {
        throw 'mockSendMetric was not called';
    }
}
function callContainsData(callData, matchData) {
    return Object.keys(matchData).every((key) => {
        return deepEqual(matchData[key], callData[key]);
    });
}
